import React, { useState } from "react";
import FormComponent from "./FormComponent";
import { Form } from "antd";
import { AppDispatch } from "../../../../store/app";
import { useDispatch } from "react-redux";
import { createSIM } from "../../../../store/SIMManagementSlice";

const AddComponent: React.FC<any> = (props) => {
  const { visible, close, getList } = props;
  const [check, setCheck] = useState(true);
  const [form] = Form.useForm();
  const dispatch: AppDispatch = useDispatch();
  const handleSubmit = (data: any) => {
    data.status = check;
    dispatch(createSIM(data))
      .then(() => {
        getList();
        handleClose();
        form.resetFields();
      })
      .catch((e: any) => {
        console.warn(e);
      });
  };
  const handleClose = () => {
    setCheck(true)
    close();
    form.resetFields();
  };
  return (
    <>
      <FormComponent
        handleSubmit={handleSubmit}
        form={form}
        visible={visible}
        close={handleClose}
        title={"Add SIM Management"}
        check={check}
        setCheck={setCheck}
        type={"Add"}
      />
    </>
  );
};

export default AddComponent;
